/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalIntegration } from './PalIntegration';
import {
    PalIntegrationFromJSON,
    PalIntegrationFromJSONTyped,
    PalIntegrationToJSON,
    PalIntegrationToJSONTyped,
} from './PalIntegration';

/**
 * 
 * @export
 * @interface FindAllPalIntegrationsByFacilityId200Response
 */
export interface FindAllPalIntegrationsByFacilityId200Response {
    /**
     * 
     */
    data?: Array<PalIntegration>;
}

/**
 * Check if a given object implements the FindAllPalIntegrationsByFacilityId200Response interface.
 */
export function instanceOfFindAllPalIntegrationsByFacilityId200Response(value: object): value is FindAllPalIntegrationsByFacilityId200Response {
    return true;
}

export function FindAllPalIntegrationsByFacilityId200ResponseFromJSON(json: any): FindAllPalIntegrationsByFacilityId200Response {
    return FindAllPalIntegrationsByFacilityId200ResponseFromJSONTyped(json, false);
}

export function FindAllPalIntegrationsByFacilityId200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllPalIntegrationsByFacilityId200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(PalIntegrationFromJSON)),
    };
}

export function FindAllPalIntegrationsByFacilityId200ResponseToJSON(json: any): FindAllPalIntegrationsByFacilityId200Response {
    return FindAllPalIntegrationsByFacilityId200ResponseToJSONTyped(json, false);
}

export function FindAllPalIntegrationsByFacilityId200ResponseToJSONTyped(value?: FindAllPalIntegrationsByFacilityId200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(PalIntegrationToJSON)),
    };
}

